import React, { useEffect, useState } from 'react';

type WcbCallCodeSelectProps = {
    wcbCallCodes: Array<string>,
    changeSelectedCallCode: Function,
};

const WcbCallCodeSelect = ({ wcbCallCodes, changeSelectedCallCode }: WcbCallCodeSelectProps) => {
  const [selectedCallCode, setSelectedCallCode] = useState('');

  useEffect(() => {
    updateSelectedCallCode(wcbCallCodes.length ? wcbCallCodes[0] : '');
  }, [wcbCallCodes]);

  const updateSelectedCallCode = callCode => {
    setSelectedCallCode(callCode);
    changeSelectedCallCode(callCode);
  };

  // Not sure how to think about this, if it's expected to be a list, empty list maps onto empty list so probably not needed
  const callCodesVisible = wcbCallCodes.length > 0;

  return (
    <select
      name="wcb-phone-code"
      id="wcb-phone-code"
      className="if dropdown-select"
      aria-label="Country code"
      value={selectedCallCode}
      onChange={(e) => updateSelectedCallCode(e.target.value)}
      >
      {callCodesVisible && ( 
        wcbCallCodes.map((code, index) => (
          <option key={index} value={code.trim()}>
            {code.trim()}
          </option>
        ))
      )}
      {/* this was always disabled and hidden so just commenting out
        <option value="" disabled hidden>
          labelnotimeselected
        </option>
      */}
    </select>
  );
};

export default WcbCallCodeSelect;
